const faqPage = document.getElementById('faq-page');
const dynamicFAQs = document.querySelectorAll('.faq-pane');
const questionsParent = document.querySelector('[data-questionsParent]');

dynamicFAQs.forEach((child,index) => {
    if (index == 0){
        child.classList.add('open');
    }
    questionsParent.appendChild(child);
});

document.querySelectorAll('.faq-tabs a').forEach(faq => {
    faq.addEventListener('click',(event)=>{
        event.preventDefault();
        document.querySelectorAll('.faq-tabs li').forEach(faq_active => {
            faq_active.classList.remove('active');
        });
        event.target.closest('li').classList.add('active');
        let href = event.target.getAttribute('href');
        document.querySelectorAll('.faqtab-content .faq-pane').forEach(faq_active => {
            faq_active.classList.remove('open');
        });
        document.querySelector(`.faqtab-content ${href}`).classList.add('open');
    });
});
